/* eslint arrow-body-style: 0 */
import { frontendURL } from '../../../helper/URLHelper';
import NotificationsView from './components/NotificationsView.vue';

// BonBoZ: KHONG boc trong `SettingsWrapper` nua.
//
// Ban goc dung vo cua man Cai dat, nen bam chuong la roi vao mot man co menu
// Cai dat doc ben trai va tieu de "Cai dat" — nguoi dung tuong minh vua nhay
// vao dau do khong ro. Thong bao la man DOC LAP, khong thuoc Cai dat va cung
// khong thuoc mot trang Facebook nao: no gom thong bao cua TAT CA cac trang.
//
// Dai dieu huong tren cung VAN hien o day: no la dieu huong cua ca app chu
// khong phai cua mot trang. Giau di thi dang trong mot trang ma bam chuong la
// mat duong ve Hoi thoai/Thong ke/CRM/Cai dat.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/notifications'),
    name: 'notifications_index',
    component: NotificationsView,
    meta: {
      permissions: ['administrator', 'agent', 'custom_role'],
    },
  },
];
